import React from "react";
import { Label, TimePicker, FormErrorMessage } from "@src/common/components";
import { Controller } from "react-hook-form";
import moment from "moment";

type Props = {
  stopIndex?: number;
  label: string;
  name: string;
  control: any;
  formatTime: any;
  watchValue: boolean;
  className?: string;
  required?: boolean;
  requiredMessage?: string;
  errors?: any;
  clearErrors?: (name: string) => void;
};

function TimeWindowController({
  stopIndex,
  label,
  name,
  control,
  formatTime,
  watchValue,
  className = "",
  required = false,
  requiredMessage = "This field is required",
  errors,
  clearErrors,
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      rules={required ? { required: requiredMessage } : {}}
      render={({ field, fieldState }) => (
        <div className={`${className}`}>
          <Label className="block text-xs font-medium text-gray-700 truncate">
            {label}
            {required && (
              <span className="text-slate-400 text-xs"> (Required)</span>
            )}
          </Label>
          <TimePicker
            nullable
            size="mini"
            value={watchValue ? formatTime(watchValue) : ""}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              if (event.target.value === "") {
                field.onChange(null);
              } else {
                const timeMoment = moment(
                  moment().format("YYYY-MM-DD") + "T" + event.target.value
                );
                const timestamp = timeMoment.unix();
                field.onChange(timestamp);
                clearErrors?.(name);
              }
            }}
            error={fieldState.error ? true : false}
          />
          {errors && (
            <span className="text-red-500 ml-2 text-xs">
              <FormErrorMessage errors={errors} name={name} />
            </span>
          )}
        </div>
      )}
    />
  );
}

export default TimeWindowController;
